// 任务
const state = {
  displayLogin: false,
  teaPlanTerm: '登录',
}

const mutations = {
  isDisplayLogin(state, res) {
    state.displayLogin = res
  },
  teaPlanTerm(state, res) {

    state.teaPlanTerm = res
  },

}

export default {
  state,
  mutations
}